<template>

  <div class="app-container" v-if="canList">
    <div class="filter-container">
      <!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
      <!--                      placeholder="活动名称"-->
      <!--                      v-model="listQuery.entity.lotteryAct.name">-->
      <!--            </el-input>-->
      <!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
      <!--                      placeholder="消耗数量"-->
      <!--                      v-model="listQuery.entity.lotteryAct.amount">-->
      <!--            </el-input>-->
      <!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
      <!--                      placeholder="抽奖总数"-->
      <!--                      v-model="listQuery.entity.lotteryAct.number">-->
      <!--            </el-input>-->
      <!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
      <!--                      placeholder="限制次数"-->
      <!--                      v-model="listQuery.entity.lotteryAct.count">-->
      <!--            </el-input>-->
      <!--            <el-select @change='handleFilter' clearable class="filter-item input" style="width: 130px"-->
      <!--                       v-model="listQuery.entity.lotteryAct.status"-->
      <!--                       placeholder="状态">-->
      <!--                <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item" :value="index">-->
      <!--                </el-option>-->
      <!--            </el-select>-->
      <!--            <el-date-picker-->
      <!--                    @change='handleFilter'-->
      <!--                    value-format="yyyy-MM-dd HH:mm:ss"-->
      <!--                    class="filter-item input"-->
      <!--                    v-model="listQuery.entity.lotteryAct.startTimes"-->
      <!--                    type="datetimerange"-->
      <!--                    range-separator="至"-->
      <!--                    start-placeholder="开始时间开始日期"-->
      <!--                    end-placeholder="开始时间结束日期">-->
      <!--            </el-date-picker>-->
      <!--            <el-date-picker-->
      <!--                    @change='handleFilter'-->
      <!--                    value-format="yyyy-MM-dd HH:mm:ss"-->
      <!--                    class="filter-item input"-->
      <!--                    v-model="listQuery.entity.lotteryAct.endTimes"-->
      <!--                    type="datetimerange"-->
      <!--                    range-separator="至"-->
      <!--                    start-placeholder="结束时间开始日期"-->
      <!--                    end-placeholder="结束时间结束日期">-->
      <!--            </el-date-picker>-->

      <div style="display: inline-block">

        <el-button style="margin-left: 10px;" class="filter-item" type="primary" v-waves icon="el-icon-search"
                   @click="handleFilter">查找
        </el-button>
        <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"
                   v-if="canSave" icon="el-icon-edit">添加
        </el-button>
        <!--                <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"-->
        <!--                           @click="handleDownload">导出-->
        <!--                </el-button>-->
      </div>
    </div>

    <el-table :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
              style="width: 100%;">
      <yf-table-column align="center" label="ID">
        <template slot-scope="scope">
          <span>{{ scope.row.lotteryAct.id }}</span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="活动名称">
        <template slot-scope="scope">
          <span v-if="scope.row.lotteryAct">{{ scope.row.lotteryAct.name }}</span>
        </template>
      </yf-table-column>
      <!--      <yf-table-column align="center" label="消耗数">-->
      <!--        <template slot-scope="scope">-->
      <!--          <span v-if="scope.row.lotteryAct">{{ scope.row.lotteryAct.amount }}</span>-->
      <!--        </template>-->
      <!--      </yf-table-column>-->

      <!--            <yf-table-column align="center" label="限制次数">-->
      <!--                <template slot-scope="scope">-->
      <!--                    <span v-if="scope.row.lotteryAct">{{scope.row.lotteryAct.count}}</span>-->
      <!--                </template>-->
      <!--            </yf-table-column>-->
      <yf-table-column align="center" label="状态">
        <template slot-scope="scope">
                                                <span v-if="scope.row.lotteryAct">

                         <el-tag :type="tagTypes[scope.row.lotteryAct.status]" v-if="scope.row.lotteryAct.status!=null">     {{
                             statusOptions[scope.row.lotteryAct.status]
                           }}</el-tag>

                        </span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="开始时间" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.lotteryAct">{{ parseTime(scope.row.lotteryAct.startTime) }}</span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="结束时间" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.lotteryAct">{{ parseTime(scope.row.lotteryAct.endTime) }}</span>
        </template>
      </yf-table-column>

      <yf-table-column align="center" label="抽奖数">
        <template slot-scope="scope">
          <span v-if="scope.row.lotteryAct">{{ scope.row.lotteryAct.number }}</span>
        </template>
      </yf-table-column>

      <yf-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" v-if="canUpdate" size="mini" @click="handleUpdate(scope)">编辑</el-button>
          <el-button v-if="canSave" size="mini" type="danger"
                     @click="handleDelete(scope)">删除
          </el-button>
<!--          <el-button size="mini" @click="updateLottery(scope)">生成</el-button>-->
<!--          <el-button size="mini" @click="renew(scope)">恢复</el-button>-->
        </template>
      </yf-table-column>

    </el-table>

    <div class="pagination-container" style="margin-top: 20px">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                     layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="120px"
               style='width: 450px; margin-left:50px;'>
                <el-form-item label="活动名称" prop="lotteryAct.name">
                  <el-input v-model="temp.lotteryAct.name"></el-input>
                </el-form-item>
<!--        <el-form-item label="中奖概率" prop="lotteryAct.amount">-->
<!--          <el-input placeholder="如10%填0.1" v-model="temp.lotteryAct.amount"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="奖品总数" prop="lotteryAct.number">-->
<!--          <el-input placeholder="会有几单的误差" v-model="temp.lotteryAct.number"></el-input>-->
<!--        </el-form-item>-->
        <!--        <el-form-item label="限制次数" prop="lotteryAct.count">-->
        <!--          <el-input v-model="temp.lotteryAct.count"></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item label="状态" prop="lotteryAct.status">
          <el-select class="filter-item" v-model="temp.lotteryAct.status" placeholder="状态">
            <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item"
                       :value="index">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="开始时间" prop="lotteryAct.startTime">
          <el-date-picker v-model="temp.lotteryAct.startTime" type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="lotteryAct.endTime">
          <el-date-picker v-model="temp.lotteryAct.endTime" type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间">
          </el-date-picker>
        </el-form-item>
        <!--        <el-form-item label="奖品图" prop="lotteryAct.actImg">-->
        <!--          <el-upload-->
        <!--              ref="actImgUpload"-->
        <!--              action="https://upload.qiniup.com"-->
        <!--              :auto-upload="true"-->
        <!--              list-type="picture-card"-->
        <!--              :on-preview="handlePictureCardPreview"-->
        <!--              :before-upload="handleUpload"-->
        <!--              :file-list="actImgList"-->
        <!--              :on-success="(response, file, fileList)=>handleImgUploadSuccess(actImgList,file)"-->
        <!--              :data="qData"-->
        <!--              :on-remove="(file, fileList)=>handleImgRemove(actImgList,file)">-->
        <!--            <i class="el-icon-plus"></i>-->
        <!--          </el-upload>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="背景图" prop="lotteryAct.bgImg">-->
        <!--          <el-upload-->
        <!--              ref="bgImgUpload"-->
        <!--              action="https://upload.qiniup.com"-->
        <!--              :auto-upload="true"-->
        <!--              list-type="picture-card"-->
        <!--              :on-preview="handlePictureCardPreview"-->
        <!--              :before-upload="handleUpload"-->
        <!--              :file-list="bgImgList"-->
        <!--              :on-success="(response, file, fileList)=>handleImgUploadSuccess(bgImgList,file)"-->
        <!--              :data="qData"-->
        <!--              :on-remove="(file, fileList)=>handleImgRemove(bgImgList,file)">-->
        <!--            <i class="el-icon-plus"></i>-->
        <!--          </el-upload>-->
        <!--        </el-form-item>-->

        <el-dialog :visible.sync="dialogVisible" append-to-body>
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialogForm">取消</el-button>
        <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
        <el-button v-else type="primary" @click="updateData">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style type="stylus">
.filter-container {
  /*padding-bottom: 20px;*/
}

.filter-item {
  margin-bottom: 10px;
}

.filter-item.input {
  /*line-height: 60px*/
  margin-right: 10px;
}
</style>

<script>
import {list, options, down, info, save, update, remove, updateLottery, renew} from '@/api/lottery_act'
import waves from '@/directive/waves' // 水波纹指令
import {downExcel} from '@/utils/down.js'
import {parseTime} from '@/utils'

import {getToken, domain} from '@/api/qiniu'
import {listToStrs, strsToList} from '@/utils/imgUtil'

import {mapGetters} from 'vuex'
import {hasAuth} from '@/utils/auth'

export default {
  name: 'test',
  directives: {
    waves
  },
  data() {
    return {
      tableKey: 0,
      list: null,
      total: null,
      listLoading: true,
      startTime: null
      ,
      endTime: null
      ,
      listQuery: {
        page: 1,
        limit: 20,
        order: 'lotteryAct.id desc',
        entity: {
          lotteryAct:
              {
                id: null,
                name: null,
                status: null,
                startTime: null,
                endTime: null,
                amount: null,
                actImg: null,
                bgImg: null,
                number: null,
                count: null
              }
        }
      },
      statusOptions: ['关闭', '开启'],

      tagTypes: ['info', '', 'warning', 'danger', 'warning'],
      temp: {

        lotteryAct:
            {
              id: null,
              name: null,
              status: null,
              startTime: null,
              endTime: null,
              amount: null,
              actImg: null,
              bgImg: null,
              number: null,
              count: null
            }


      }
      ,
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '修改',
        create: '新增'
      }
      ,
      // 存在图片
      dialogImageUrl: '',
      dialogVisible: false,
      actImgList: [],
      bgImgList: [],
      rules:
          {
            'lotteryAct.name': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'lotteryAct.status': [
              {
                required: false,
                message: '必填字段',
                trigger: 'blur'
              }
            ]
            ,
            'lotteryAct.startTime': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'lotteryAct.endTime': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'lotteryAct.amount': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'lotteryAct.actImg': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'lotteryAct.bgImg': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'lotteryAct.number': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'lotteryAct.count': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
          }
      ,
      downloadLoading: false,
      qData:
          {
            token: '',
            key: ''
          }
    }
  },
  created() {
    this.getList()
    this.getOptions()
  },
  computed: {
    ...mapGetters([
      'perms'
    ]),
    canSave() {
      return hasAuth(this.perms, 'lottery:act:save')
    },
    canDelete() {
      return hasAuth(this.perms, 'lottery:act:delete')
    },
    canUpdate() {
      return hasAuth(this.perms, 'lottery:act:update')
    },
    canList() {
      return hasAuth(this.perms, 'lottery:act:list')
    }
  },
  methods: {
    parseTime(time) {
      if (!time) return ''
      return parseTime(time, '{y}-{m}-{d} {h}:{i}:{s}')
    },
    getList() {
      this.listLoading = true
      list(this.listQuery).then(response => {
        this.list = response.data.list
        this.total = response.data.total
        this.listLoading = false
      })
    },
    getOptions() {
      options().then(res => {
        this.statusOptions = res.data.statusOptions
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    handleModifyStatus(row, status) {
      this.$message({
        message: '操作成功',
        type: 'success'
      })
      row.status = status
    },
    beforeFormShow(row) {
      this.resetTemp(row) // 更新数据
      // 存在图片
      this.initQiniu()

      // 存在图片字段转换图片地址显示
      this.initImgUrl()
    },
    afterFormShow(row) {

    },
    beforeFormCommit() {
      this.initImgName()// 图片转换
    },
    resetTemp(row) {

      this.temp = {
        lotteryAct: {}
      }
      if (row) {
        this.temp = Object.assign({}, row) // copy obj
      }

    },
    handleCreate() {
      this.beforeFormShow()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.afterFormShow()
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleDelete(scope) {
      this.index = scope.$index
      // this.beforeFormShow(scope.row)
      // this.temp = Object.assign({}, row) // copy obj
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.$message({
        //   type: 'success',
        //   message: '删除成功!'
        // })
        this.deleteData()
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '删除失败'
        })
      })
    },
    // 显示将图片名封装成可以展示状态集合
    initImgUrl() {
      this.actImgList = strsToList(this.temp.lotteryAct.actImg, domain)
      this.bgImgList = strsToList(this.temp.lotteryAct.bgImg, domain)
    },
    // 关闭显示窗口 重置图片地址 防止错乱
    resetImgUrl() {
      this.actImgList = []
      this.bgImgList = []
    },
    // 上传或者更新的时候从图片链接中获取图片名字
    initImgName() {
      this.temp.lotteryAct.actImg = listToStrs(this.actImgList)
      this.temp.lotteryAct.bgImg = listToStrs(this.bgImgList)
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
            if (valid) {
              this.beforeFormCommit()

              save(this.temp).then(res => {
                this.temp = res.data
                this.list.unshift(this.temp)
                this.closeDialogForm()
                this.$notify({
                  title: '成功',
                  message: '创建成功',
                  type: 'success',
                  duration: 2000
                })
              })
            }
          }
      )
    },
    deleteData() {
      // const ids = [this.temp.lotteryAct.id]
      const ids = [this.list[this.index].lotteryAct.id]
      remove({ids: ids}).then(res => {
        // 从当前队列中移除
        this.list.splice(this.index, 1)
        this.$notify({
          title: '成功',
          message: '删除成功',
          type: 'success',
          duration: 2000
        })
      })
    },
    handleUpdate(scope) {
      this.beforeFormShow(scope.row)
      info(scope.row.lotteryAct.id).then(res => {
        this.temp = res.data
        this.dialogStatus = 'update'
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      })
    },
    updateLottery(scope) {
      this.beforeFormShow(scope.row)
      updateLottery(scope.row.lotteryAct.id).then(() => {
        // this.list.splice(this.index, 1, this.temp)
        this.getList()
        this.closeDialogForm()
        this.$notify({
          title: '成功',
          message: '生成成功',
          type: 'success',
          duration: 2000
        })
      })
    },
    renew(scope) {
      this.beforeFormShow(scope.row)
      renew(scope.row.lotteryAct.id).then(() => {
        // this.list.splice(this.index, 1, this.temp)
        this.getList()
        this.closeDialogForm()
        this.$notify({
          title: '成功',
          message: '恢复成功',
          type: 'success',
          duration: 2000
        })
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
            if (valid) {
              this.beforeFormCommit()
              update(this.temp).then(() => {
                // this.list.splice(this.index, 1, this.temp)
                this.getList()
                this.closeDialogForm()
                this.$notify({
                  title: '成功',
                  message: '更新成功',
                  type: 'success',
                  duration: 2000
                })
              })
            }
          }
      )
    },
    closeDialogForm() {
      // 存在图片
      this.resetImgUrl()
      this.dialogFormVisible = false
    },
    handleDownload() {
      this.downloadLoading = true
      down(this.listQuery).then(res => {
        downExcel(res)
        this.downloadLoading = false
        this.$notify({
          title: '成功',
          message: '下载成功',
          type: 'success',
          duration: 2000
        })
      })
    },
    // formatJson(filterVal, jsonData) {
    //     return jsonData.map(v => filterVal.map(j => {
    //         return v[j]
    //     }
    // ))
    // },
    // 存在图片
    handleUpload(file) {
      this.qData.key = new Date().valueOf() + file.name
    },
    initQiniu() {
      // 获取七牛配置
      getToken().then(res => {
        this.qData.token = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    handleImgUploadSuccess(imgList, file) {
      imgList.push({name: file.response.key, url: domain + file.response.key})
    },
    handleImgRemove(imgList, file) {
      for (var fn of imgList) {
        if (fn.name === file.name) {
          imgList.splice(imgList.indexOf(fn), 1)
        }
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  }
}
</script>
